import React from "react";
import ReactTable from "react-table";
import "../../style/helper.css";
import "../../style/styles.css";
import ApiService from "../../Services/ApiService.js";
import { Link } from "react-router-dom";
import LoadingScreen from "../misc/loading.js";
import ErrorScreen from "../misc/error.js";
import AlertService from "../../Services/AlertService";

class ClientAudienceList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            client_id: props.data.client_id,
            loading: true,
            data: [],
            error: false
        }

        this.fetchClientAudiences();
    }

    onColumnClick = (state, rowInfo, column, instance) => {
        return {
            onClick: e => {

                if (column.Header !== "Action") {
                    let id = rowInfo.row._original.id;
                    this.props.history.push("/clients/add-audience?id=" + id)
                }
            }
        }
    };

    handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this audience?')) {
            ApiService.post('/api/clients/delete-audience', { 'id': id })
                .then(response => {
                    this.fetchClientAudiences();
                });
        }

    };


    fetchClientAudiences() {
        ApiService.get("/api/clients/audiences?client_id=" + this.state.client_id)
            .then(response => {

                if (response.data.Success) {
                    let audiences = response.data.Audiences;

                    audiences.forEach((audience) => {

                        let jobFunctions = audience.job_functions;
                        let jobFunctionNames = jobFunctions ? Object.values(jobFunctions).join(', ') : '';

                        audience.job_functions = jobFunctionNames;
                        audience.seniorities = audience.seniorities.join(', ');
                        audience.job_titles = audience.job_titles.join(', ');
                        audience.job_skills = audience.job_skills.join(', ');
                        audience.locations = audience.locations.join(', ');
                        audience.is_default = audience.is_default === 1 ? 'Yes' : 'No';

                    });

                    let reversed = audiences.reverse();

                    this.setState({
                        data: reversed,
                        loading: false,
                        error: false
                    });
                } else {
                    this.setState({
                        loading: false,
                        error: true
                    });
                }

            });
    }


    render() {
        const { loading, error, data } = this.state;
        if (loading) {
            return <LoadingScreen />;
        }
        if (error) {
            return <ErrorScreen />;
        }
        const columns = [
            {
                Header: "Name",
                accessor: "name",
                width: 125
            },
            {
                Header: "Language",
                accessor: "locale",
                width: 125
            },
            {
                Header: "Locations",
                accessor: "locations",
                style: { 'whiteSpace': 'unset' },

            },
            {
                Header: "Job Titles",
                accessor: "job_titles",
                style: { 'whiteSpace': 'unset' },

            },
            {
                Header: "Job Skills",
                accessor: "job_skills",
                style: { 'whiteSpace': 'unset' },

            },
            {
                Header: "Job Functions",
                accessor: "job_functions",
                style: { 'whiteSpace': 'unset' },

            },
            {
                Header: "Seniorities",
                accessor: "seniorities",
                style: { 'whiteSpace': 'unset' },
                width: 150,

            },
            {
                Header: "Default",
                accessor: "is_default",
                style: { 'whiteSpace': 'unset' },
                width: 100,

            },
            {
                Header: "Action",
                width: 75,
                Cell: (data) => {
                    if (data && data.row._original.id) {
                        let id = data.row._original.id;
                        return (
                            <div>
                                <button className="table-btn" onClick={() => this.handleDelete(id)}> <i className="fa fa-trash-o"></i> </button>

                            </div>
                        )
                    } else {
                        return ("");
                    }
                }
            }
        ];

        return (
            <div className="page-main">
                <div>
                    <button className="add-btn btn-large" onClick={() => { this.props.history.push("/clients/add-audience?client_id=" + this.props.data.client_id) }}>
                        Add Audience
                    </button>
                </div>

                <div className="page-content">
                    <div className="table-style client-list">
                        <ReactTable
                            data={data}
                            columns={columns}
                            showPagination={true}
                            minRows={0}
                            getTdProps={this.onColumnClick}
                            defaultPageSize={50}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default ClientAudienceList;
